import * as React from "react";
import Breadcrumbs from "./../common/components/FDIC/Breadcrumbs";
import ErrorMessage from "./../common/containers/ErrorMessage";
import MainContent from "../common/components/MainContent";
import DataLoader from "./../common/containers/DataLoader";
import { messages } from "./../refdata/UserMessages";
import Filters from "./components/Filters";
import HelpButton from "./containers/HelpButton";
import "../common/styles/App.css";
import FeedbackLink from "../components/FeedbackLink";
import ReturnToLandingPageButton from "../common/components/ReturnToLandingPageButton";

class App extends React.Component {
  componentDidMount() {
    document.title = "Historical Bank Data";
  }
  public render() {
    return (
      <div>
        <Breadcrumbs pageTitle="Historical Bank Data" />
        <div id="content">
          <DataLoader />
          <ReturnToLandingPageButton />
          <div className="ds-u-padding-bottom--3">
            <div className="screenOnly">
              <HelpButton />
            </div>
            <h1>BankFind Suite: Find Annual Historical Bank Data</h1>
            <p className="screenOnly">{messages.intro.historical}</p>
            <FeedbackLink appName="HistoricalBankData" />
            <ErrorMessage />
          </div>
          <MainContent filters={Filters} />
        </div>
      </div>
    );
  }
}

export default App;
